<template><div class="main">
  <sticky-bar>Page Not Found</sticky-bar>
  <p>The requested page does not exist. Try visiting your <router-link to="/">diagnostics dashboard</router-link>.</p>
</div></template>
<script>
import StickyBar from './StickyBar'
export default {
  name: 'NotFound',
  components: { StickyBar },
}
</script>
